import React from 'react';
import _ from 'lodash';
import { includesSearchWord } from 'utils';
import { get10LastLetters } from 'utils/validations';
import moment from 'moment';

export const filterTableData = (data, filters, keyword) => {
    let result = data;
    if (filters && Object.values(filters).some(v => v !== undefined && v !== null && v !== '')) {
        result = result.filter(item => {
            const fields = Object.keys(filters);
            const inValid = !!fields.find(el => {
                const filterVal = filters[el];
                if (filterVal === undefined || filterVal === null || filterVal === '') return false;
                const itemVal = _.get(item, el);
                return itemVal != filterVal;
            });
            return !inValid;
        });
    }
    if (keyword && keyword.length > 0) {
        result = result.filter(item => item && !!Object.values(item).find(value => value && includesSearchWord(value, keyword)))
    }
    return result
}

export const getTableBodyNoMatchMessage = (formatMessage, dataLoading) =>
    formatMessage({
        id: dataLoading
            ? 'muitable.placeholder.loading'
            : 'muitable.placeholder.nomatch_records',
    });

export const mergeTableLoadingOptions = (formatMessage, options, dataLoading) => {
    const base = options || {};
    return {
        ...base,
        textLabels: {
            ...base.textLabels,
            body: {
                ...(base.textLabels?.body || {}),
                noMatch: getTableBodyNoMatchMessage(formatMessage, !!dataLoading),
            },
        },
    };
};

export const isTableInitialLoading = (dataLoading, datasource) =>
    !!dataLoading && !(datasource && datasource.length > 0);

export const prepareTableDisplay = ({ formatMessage, dataLoading, datasource, options, fixed }) => {
    const isInitialLoad = isTableInitialLoading(dataLoading, datasource);
    const baseOptions = options || tableOptions(formatMessage, fixed);
    return {
        data: isInitialLoad ? [] : (datasource || []),
        options: mergeTableLoadingOptions(formatMessage, baseOptions, isInitialLoad),
    };
};

export const tableOptions = (formatMessage, fixed, dataLoading) => {
    const options = {
        pagination: false,
        print: false,
        download: false,
        selectableRows: 'none',
        searchable: false,
        viewColumns: false,
        elevation: 0,
        filter: false,
        search: false,
        textLabels: {
            body: {
                noMatch: getTableBodyNoMatchMessage(formatMessage, !!dataLoading),
            },
            filter: {
                all: formatMessage({ id: 'all' }),
                title: formatMessage({ id: 'filters' }),
                reset: formatMessage({ id: 'reset' }),
            },
        },
        ...(fixed && {
            fixedHeader: true,
            tableBodyMaxHeight: "",
            responsive: "vertical"
        } || {})
    };
    return options;
}

export const columnCreatedAt = (formatMessage, name) => {
    return {
        name: name || 'createdAt',
        label: formatMessage({
            id: 'created_at',
        }),
        options: {
            filter: false,
            sort: true,
            customBodyRender: value => value ? moment(value).format("HH:mm DD/MM/YYYY") : "",
        },
    }
}

export const columnId = (formatMessage) => {
    return {
        name: 'id',
        label: formatMessage({
            id: 'id',
        }),
        options: {
            filter: false,
            sort: true,
            customBodyRender: value => get10LastLetters(value),
        },
    }
}

export const columnUser = (formatMessage) => {
    return [
        {
            name: 'firstName',
            label: formatMessage({ id: 'first_name' }),
            options: { filter: false, sort: true },
        },
        {
            name: 'lastName',
            label: formatMessage({ id: 'last_name' }),
            options: { filter: false, sort: true },
        },
        {
            name: 'email',
            label: formatMessage({ id: 'email' }),
            options: { filter: false, sort: true },
        },
    ]
}

export const columnActions = (customBodyRender) => {
    return {
        name: 'actions',
        label: 'Actions',
        options: {
            filter: false,
            sort: false,
            customBodyRender
        }
    }
}

export const exportOnedataUsersHeader = (formatMessage, includeStatus = true) => {
    const headers = [
        { label: formatMessage({ id: 'id' }), key: 'id' },
        { label: 'Id Contact', key: 'contactId' },
        { label: 'Nom', key: 'lastName' },
        { label: 'Prénom', key: 'firstName' },
        { label: 'Fonction', key: 'fonction' },
        { label: formatMessage({ id: 'email' }), key: 'email' },
        { label: formatMessage({ id: 'caracteristiques.field.creationDate' }), key: 'createdAt' },
        { label: formatMessage({ id: 'caracteristiques.field.idCompteSel' }), key: 'idCompteSel' },
    ];
    if (includeStatus) {
        headers.push({ label: formatMessage({ id: 'status' }), key: 'status' });
    }
    headers.push({ label: 'API', key: 'api' });
    return headers;
};

export const exportClientsHeader = (formatMessage) => {
    return [
        { label: formatMessage({ id: 'no' }), key: 'id' },
        { label: formatMessage({ id: 'company' }), key: 'company' },
        { label: formatMessage({ id: 'siret' }), key: 'siret' },
        { label: "idCompteSel", key: 'compteSEL' },
        { label: formatMessage({ id: 'first_name' }), key: 'firstName' },
        { label: formatMessage({ id: 'last_name' }), key: 'lastName' },
        { label: formatMessage({ id: 'email' }), key: 'email' },
        { label: formatMessage({ id: 'address' }), key: 'address' },
        { label: formatMessage({ id: 'zipcode' }), key: 'zipCode' },
        { label: formatMessage({ id: 'city' }), key: 'city' },
        { label: formatMessage({ id: 'country' }), key: 'country' },
        { label: formatMessage({ id: 'position' }), key: 'position' },
        { label: formatMessage({ id: 'created_at' }), key: 'createdAt' },
    ];
}

export const exportUsersHeader = (formatMessage) => {
    return [
        { label: formatMessage({ id: 'no' }), key: 'id' },
        { label: formatMessage({ id: 'avatar' }), key: 'avatar' },
        { label: formatMessage({ id: 'first_name' }), key: 'firstName' },
        { label: formatMessage({ id: 'last_name' }), key: 'lastName' },
        { label: formatMessage({ id: 'email' }), key: 'email' },
        { label: formatMessage({ id: 'company' }), key: 'company' },
        { label: formatMessage({ id: 'zipcode' }), key: 'zipCode' },
        { label: formatMessage({ id: 'status' }), key: 'status' },
        { label: "Création Autonome", key: 'selfSignup' },
        { label: formatMessage({ id: 'numLogin' }), key: 'numLogin' },
        { label: formatMessage({ id: 'lastLogin' }), key: 'lastLogin' },
        { label: formatMessage({ id: 'created_at' }), key: 'createdAt' },
    ];
}

export const columnsFromKeys = (keys, getLabel) => {
    return keys.map(key => {
        return {
            name: key,
            label: key == 'id' ? "ID" : getLabel(key),
            options: {
                filter: true,
                sort: true,
                ...key == 'id' ? { customBodyRender: value => get10LastLetters(value) } : {},
                ...key == 'createdAt' ? { customBodyRender: value => moment(value).format("DD/MM/YYYY HH:mm") } : {},
                ...(key == 'startDate' || key == "endDate") ? { customBodyRender: value => moment(value).format("DD/MM/YYYY") } : {},
            },
        }
    })
}

export const columnLoginInfo = (formatMessage) => {
    return [
        {
            name: 'numLogin',
            label: formatMessage({ id: 'numLogin' }),
            options: {
                filter: true,
                sort: true,
                customBodyRender: value => Number.parseInt(value || 0) + 1,
            },
        },
        {
            name: 'lastLogin',
            label: formatMessage({ id: 'lastLogin' }),
            options: {
                filter: true,
                sort: true,
                customBodyRender: value => value ? moment(value).format("DD/MM/YYYY HH:mm") : "",
            },
        }
    ]
}